/**
 * O convite de clube em trânsito: `lesvita.com/c/<CODIGO>`.
 *
 * Três portas chegam aqui e todas só GUARDAM o código:
 *   - a rota web `/c/:codigo` (ConviteClube), com ou sem sessão;
 *   - o `appUrlOpen` do app nativo (App Link / Universal Link de `/c/`);
 *   - quem já está dentro do app e abre o link de novo (evento abaixo).
 *
 * Quem CONSOME é a PlataformaPessoal, já logada e com o shell montado: troca o
 * código pelo clube (`listarClubes` com busca por código) e abre a página dele.
 *
 * localStorage, não sessionStorage: quem chega sem conta passa pelo cadastro
 * inteiro (OTP, objetivo) antes de cair na plataforma, e o convite precisa
 * sobreviver a isso. Vale por 7 dias — depois disso é lixo, não convite.
 */

export const CHAVE_CONVITE_PENDENTE = 'lesvita:clube-convite';
/** Disparado quando um convite chega com o app já aberto. */
export const EVENTO_CONVITE_CLUBE = 'lesvita:clube-convite';

const VALIDADE_MS = 7 * 24 * 60 * 60 * 1000;
const FORMATO = /^[ABCDEFGHJKLMNPQRSTUVWXYZ23456789]{8}$/;

/** Normaliza e valida um código de convite. @return {string|null} */
export function normalizarCodigo(codigo) {
  const limpo = String(codigo || '').trim().toUpperCase().slice(0, 8);
  return FORMATO.test(limpo) ? limpo : null;
}

/**
 * Extrai o código de `https://(www.)lesvita.com/c/<CODIGO>` ou do esquema
 * próprio `lesvita://c/<CODIGO>` (o "Já tenho o app" da página do convite).
 * @return {string|null}
 */
export function codigoDaUrl(url) {
  const m = /^(?:https?:\/\/(?:www\.)?lesvita\.com\/c\/|lesvita:\/\/c\/)([A-Za-z0-9]{8})(?:[/?#]|$)/.exec(
    String(url || '').trim()
  );
  return m ? normalizarCodigo(m[1]) : null;
}

/** O endereço público de convite de um clube (sem https://, para exibir). */
export function linkDoClube(codigo) {
  return `lesvita.com/c/${String(codigo || '').toUpperCase()}`;
}

/** Guarda o convite e avisa quem já estiver ouvindo. */
export function guardarConvite(codigo) {
  const limpo = normalizarCodigo(codigo);
  if (!limpo) return false;
  try {
    localStorage.setItem(
      CHAVE_CONVITE_PENDENTE,
      JSON.stringify({ codigo: limpo, em: Date.now() })
    );
  } catch {
    /* sem storage (modo privado): o evento ainda serve para o app aberto */
  }
  try {
    window.dispatchEvent(new CustomEvent(EVENTO_CONVITE_CLUBE, { detail: limpo }));
  } catch {
    /* ambiente sem window (teste) */
  }
  return true;
}

/** O convite guardado, se ainda valer. Consome de uma vez — não repete. */
export function consumirConvitePendente() {
  try {
    const bruto = localStorage.getItem(CHAVE_CONVITE_PENDENTE);
    if (!bruto) return null;
    localStorage.removeItem(CHAVE_CONVITE_PENDENTE);
    const { codigo, em } = JSON.parse(bruto) || {};
    if (!em || Date.now() - em > VALIDADE_MS) return null;
    return normalizarCodigo(codigo);
  } catch {
    return null;
  }
}
